// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;
import "@fortawesome/fontawesome-free/js/all.js";
